import UnstarSelectAll from './UnstarSelectAll.component';

export default UnstarSelectAll;